module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.8@core-js/library/modules/_library.js
// module id = 37
// module chunks = 0